export const ADULT_AGE = 18
export const CVV_MAX_LENGTH = 4

// Base del servidor de servicios (servicesapp). La búsqueda de la reserva, la apertura de
// puertas y el estado de los dispositivos pasan por aquí: el servidor de servicios llama al
// PMS y, si no responde, al servidor de llaves de respaldo.
export const SERVICES_SERVER_BASE_URL =
  'https://servicesapp.availroom.com/sialdPMS_Services/web/resourcescrossorigin/webcrossorigin'

// Tiempo máximo de las llamadas de domótica al servidor de servicios (PMS 5 s + servidor de
// llaves 20 s, con margen).
export const DOMOTIC_REQUEST_TIMEOUT_MS = 30000
